export type ProcessingType = (typeof ProcessingType)[keyof typeof ProcessingType];

export const ProcessingType = {
  ASSIGNMENTS_EXTRACTION: 'ASSIGNMENTS_EXTRACTION',
  ASSIGNMENTS_UPLOAD: 'ASSIGNMENTS_UPLOAD',
  CALIBRATION: 'CALIBRATION',
  CALIBRATION_UPLOAD: 'CALIBRATION_UPLOAD',
  CLUSTER_DATA_EXTRACTION: 'CLUSTER_DATA_EXTRACTION',
  IDENTIFICATION: 'IDENTIFICATION',
  IDENTIFICATION_REFINEMENT: 'IDENTIFICATION_REFINEMENT',
  SESSION_RESOURCES: 'SESSION_RESOURCES',
  SESSION_UPDATE: 'SESSION_UPDATE',
  SESSION_VALIDATION: 'SESSION_VALIDATION',
  STATISTICS: 'STATISTICS',
  STATISTICS_IMPORT: 'STATISTICS_IMPORT',
  STATISTICS_RESOURCES: 'STATISTICS_RESOURCES',
  TRACK_CLUSTERING: 'TRACK_CLUSTERING',
  TRACK_EXTRACTION: 'TRACK_EXTRACTION',

  // Deprecated - keep for backward compatibility
  CALIBRATION_SETUP: 'CALIBRATION_SETUP',
  LPS_AUTO_ASSIGNMENT: 'LPS_AUTO_ASSIGNMENT',
  POSITIONS: 'POSITIONS',
  POSITIONS_RESOURCES: 'POSITIONS_RESOURCES',
} as const;
